<template>
    <section class="cabinet-content-wrap">
        <p v-if="loading" class="mt-3">Loading...</p>

        <div v-if="!loading && !error">
            <HeaderPublic />

            <section class="cabinet__breadcrumbs">
                <router-link to="/" class="cabinet__breadcrumbs-link"
                    >Главная</router-link
                >
                <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                <router-link
                    to="/account/brands"
                    class="cabinet__breadcrumbs-link"
                    >Бренды</router-link
                >
            </section>

            <div class="v2-retailer-brand__header">
                <div class="v2-retailer-brand__header-logo app-link">
                    <img
                        class="v2-retailer-brand__header-img ofi"
                        :src="brand.logo"
                        @click="activeTab = 1"
                    />
                </div>

                <div class="v2-retailer-brand__header-descr">
                    <h1
                        class="h1 cabinet-title cabinet-supplier-header__title v2-retailer-brand__header-title"
                    >
                        {{ brand.BrandName }}
                    </h1>
                    <button
                        class="cabinet-btn cabinet-btn--transparent2 cabinet-btn--small v2-retailer-brand__header-message"
                        @click="openMessageModal()"
                    >
                        Отправить сообщение
                    </button>
                    <div
                        v-click-outside="hideSubmenu"
                        class="v2-retailer-brand__header-more"
                        @click="toggleSubmenu"
                    >
                        <button
                            type="button"
                            class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--small cabinet-btn-icon--more d-block"
                        ></button>
                        <div
                            v-if="isSubmenuOpened"
                            class="app-dropdown app-dropdown--bottom app-dropdown--left v2-retailer-brand__header-dropdown"
                            @click.stop=""
                        >
                            <div
                                class="v2-retailer-brand__header-dropdown-item"
                            >
                                <div
                                    class="cabinet-btn-icon cabinet-btn-icon--small cabinet-btn-icon--favorite"
                                    :class="{ active: isFavourite }"
                                    @click="changeFavourite(brand, isFavourite)"
                                ></div>
                                В избранное
                            </div>
                            <div
                                class="v2-retailer-brand__header-dropdown-item"
                            >
                                <label class="app-checkbox">
                                    <input
                                        v-model="isSubscribed"
                                        type="checkbox"
                                        @click="
                                            changeSubscription(
                                                brand,
                                                isSubscribed
                                            )
                                        "
                                    />
                                    <span
                                        class="app-checkbox__checkmark"
                                    ></span>
                                    Получать уведомления о новинках
                                </label>
                            </div>
                            <div
                                v-if="brand.has_restricted_items"
                                class="v2-retailer-brand__header-dropdown-item flex-wrap align-items-start"
                            >
                                <i
                                    class="mr-2"
                                    :class="
                                        brand.approved_access_to_restricted_items
                                            ? 'icon-unlock'
                                            : 'icon-lock'
                                    "
                                ></i>
                                <div
                                    class="v2-retailer-brand__header-dropdown-info"
                                >
                                    {{
                                        brand.approved_access_to_restricted_items
                                            ? 'Вам открыт доступ к скрытым изделиям этого бренда'
                                            : 'У бренда есть скрытые изделия'
                                    }}
                                </div>
                                <a
                                    v-if="
                                        brand.access_status === null ||
                                            brand.access_status === 'forbidden'
                                    "
                                    href="#"
                                    class="v2-retailer-brand__header-dropdown-access"
                                    @click.prevent="
                                        openRequestAccessModal(brand)
                                    "
                                >
                                    Запросить доступ
                                </a>

                                <span
                                    v-if="brand.access_status === 'new'"
                                    class="v2-retailer-brand__header-dropdown-access grey"
                                    >Запрос доступа отправлен</span
                                >
                            </div>
                            <div
                                class="v2-retailer-brand__header-dropdown-item d-md-none"
                            >
                                <div @click="openMessageModal()">
                                    Отправить сообщение
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none d-lg-flex pt-4 align-items-center">
                <div class="d-flex align-items-center mr-3 pr-4">
                    <div
                        class="cabinet-btn-icon cabinet-btn-icon--small cabinet-btn-icon--favorite mr-1"
                        :class="{ active: isFavourite }"
                        @click="changeFavourite(brand, isFavourite)"
                    ></div>
                    В избранное
                </div>
                <label class="app-checkbox">
                    <input
                        v-model="isSubscribed"
                        type="checkbox"
                        @click="changeSubscription(brand, isSubscribed)"
                    />
                    <span class="app-checkbox__checkmark"></span>
                    Получать уведомления о новинках
                </label>

                <div
                    v-if="brand.has_restricted_items"
                    class="cabinet-table__access ml-3 pl-4 d-flex align-items-center mr-0 w-auto"
                >
                    <i
                        class="mr-2"
                        :class="
                            brand.approved_access_to_restricted_items
                                ? 'icon-unlock'
                                : 'icon-lock'
                        "
                    ></i>
                    <template>
                        {{
                            brand.approved_access_to_restricted_items
                                ? 'Вам открыт доступ к скрытым изделиям этого бренда'
                                : 'У бренда есть скрытые изделия'
                        }}
                    </template>
                    <a
                        v-if="
                            brand.access_status === null ||
                                brand.access_status === 'forbidden'
                        "
                        href="#"
                        class="ml-2"
                        @click.prevent="openRequestAccessModal(brand)"
                    >
                        Запросить доступ
                    </a>

                    <span v-if="brand.access_status === 'new'" class="pl-2"
                        >Запрос доступа отправлен</span
                    >
                </div>
            </div>

            <cabinet-tabs
                :tabs="tabs"
                :active="activeTab"
                :wrapper-classes="['v2-retailer-brand__nav']"
            >
                <div slot="0">
                    <section class="cabinet-supplier-detail">
                        <div class="cabinet-supplier-tab-content">
                            <brand-products ref="product-list" :brand="brand" />
                        </div>
                    </section>
                </div>
                <div slot="1">
                    <section class="cabinet-supplier-detail">
                        <div class="cabinet-supplier-tab-content">
                            <brand-about :brand="brand"></brand-about>
                        </div>
                    </section>
                </div>
                <div slot="2">
                    <section class="cabinet-supplier-detail">
                        <div
                            class="cabinet-supplier-tab-content cabinet-settings--doc cabinet-settings-documents cabinet-settings-documents--download"
                        >
                            <div
                                v-if="docs"
                                class="cabinet-settings-documents__list cabinet-settings-documents__list--download"
                            >
                                <a
                                    v-for="doc in staticDocs"
                                    :key="doc.id"
                                    :href="`${doc.filename}`"
                                    download
                                    target="_blank"
                                    class="cabinet-settings-documents__item"
                                >
                                    <div
                                        class="cabinet-settings-documents__item-title subtitle2 flex"
                                    >
                                        {{ doc.document_name }}
                                    </div>
                                </a>
                                <div
                                    v-if="contractDocs.length > 0"
                                    class="cabinet-settings-documents__subtitle subtitle1"
                                >
                                    Бланк(и) Договора(ов)
                                </div>
                                <a
                                    v-for="doc in contractDocs"
                                    :key="doc.id"
                                    :href="`${doc.filename}`"
                                    download
                                    target="_blank"
                                    class="cabinet-settings-documents__item"
                                >
                                    <div
                                        class="cabinet-settings-documents__item-title subtitle2 flex"
                                    >
                                        {{ doc.document_name }}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </section>
                </div>
            </cabinet-tabs>

            <request-access-modal
                :is-open="isOpenRequestAccessBrandModal"
                :brand="brand"
                @onConfirm="sendBrandAccessRequest"
                @onClose="closeRequestAccessModal"
            />

            <message-modal
                :is-open="isMessageModalOpen"
                :user-to="brand.supplier || {}"
                :brand="brand || {}"
                @closeModal="onCloseMessageModal"
                @onSend="onMessageSend"
            />
        </div>
        <div v-if="!loading && error">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="tryGetBrand"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import CabinetTabs from '@/components/Cabinet/Tabs'
import BrandAbout from '@/components/Public/Brand/About'
import BrandProducts from '@/components/Public/Brand/Products'
import RequestAccessModal from '@/components/Cabinet/Retailer/Brands/RequestAccessModal'
import MessageModal from '@/components/Cabinet/Retailer/Brands/MessageModal'
import HeaderPublic from '@/components/Public/PublicHeader'

import checkDemoUser from '@/mixins/checkDemoUser.js'

import vClickOutside from 'v-click-outside'

export default {
    name: 'RetailerBrandsID',
    components: {
        CabinetTabs,
        BrandAbout,
        BrandProducts,
        RequestAccessModal,
        MessageModal,
        HeaderPublic
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    mixins: [checkDemoUser],
    data() {
        return {
            currentBrandID: this.$route.params.id,
            brand: {},
            isFavourite: false,
            isSubscribed: false,
            isOpenRequestAccessBrandModal: false,
            activeTab: 0,
            isMessageModalOpen: false,
            error: false,
            isSubmenuOpened: false,
            loading: true,
            tabs: ['Изделия', 'О компании', 'Документы']
        }
    },
    computed: {
        ...mapState('supplierDocs', ['docs']),
        staticDocs() {
            return this.docs.filter(d => d.type !== 'contract')
        },
        contractDocs() {
            return this.docs.filter(d => d.type == 'contract')
        },
        APP_URL() {
            return process.env.VUE_APP_URL_APP
        }
    },
    async created() {
        await this.getBrand(this.currentBrandID)
    },
    beforeRouteEnter(to, from, next) {
        console.log(from)
        if (from.name !== 'RetailerProductID') {
            localStorage.removeItem('retailer-catalog-data')
        }

        next()
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === 'RetailerProductID') {
            const { filter, search, view, pagination, sort } = this.$refs[
                'product-list'
            ].$children[0]
            const retailerCatalogData = {
                filter,
                search,
                view,
                pagination,
                sort
            }

            localStorage.setItem(
                'retailer-catalog-data',
                JSON.stringify(retailerCatalogData)
            )
        } else {
            localStorage.removeItem('retailer-catalog-data')
        }

        next()
    },
    methods: {
        ...mapActions('retailerBrand', [
            'subscribeOnBrand',
            'unsubscribeOnBrand',
            'addBrandInFavourite',
            'removeBrandFromFavourite',
            'requestAccessToBrand'
        ]),
        ...mapActions('supplierDocs', ['getDocs']),
        getBrand(brandID) {
            this.error = false
            this.$Progress.start()
            this.loading = true
            this.$axios
                .get(`/retailer/brands/${brandID}`)
                .then(response => {
                    this.error = false
                    this.brand = response.data
                    this.isFavourite = response.data.is_favorited
                    this.isSubscribed = response.data.is_subscribed
                    this.getDocs(this.brand.supplier.id)
                    this.$Progress.finish()
                    this.loading = false
                })
                .catch(error => {
                    this.error = true
                    this.$Progress.finish()
                    this.loading = false
                })
        },
        changeSubscription(brand, isSubscribed) {
            if (this.isDemoUserMode()) {
                setTimeout(() => {
                    this.isSubscribed = this.brand.is_subscribed
                }, 5)
                return
            }

            if (isSubscribed) {
                this.unsubscribeOnBrand(brand.BrandID).then(() => {
                    this.$notify({
                        type: 'success',
                        text: `Вы отписались от бренда “${brand.BrandName}”`
                    })
                })
            } else {
                this.subscribeOnBrand(brand.BrandID).then(() => {
                    this.$notify({
                        type: 'success',
                        text: `Вы подписались на бренд “${brand.BrandName}”`
                    })
                })
            }
        },
        changeFavourite(brand, isFavourite) {
            if (this.isDemoUserMode()) return

            if (isFavourite) {
                this.removeBrandFromFavourite(brand.BrandID).then(() => {
                    this.$notify({
                        type: 'success',
                        text: `Бренд “${brand.BrandName}” удален из избранного`
                    })
                })
            } else {
                this.addBrandInFavourite(brand.BrandID).then(() => {
                    this.$notify({
                        type: 'success',
                        text: `Бренд “${brand.BrandName}” добавлен в избранное`
                    })
                })
            }

            this.isFavourite = !this.isFavourite
        },
        openRequestAccessModal() {
            this.isOpenRequestAccessBrandModal = true
            this.hideSubmenu()
        },
        closeRequestAccessModal() {
            this.isOpenRequestAccessBrandModal = false
        },
        sendBrandAccessRequest(brand) {
            if (this.isDemoUserMode()) return

            this.requestAccessToBrand(brand.BrandID).then(() => {
                this.$notify({
                    type: 'success',
                    text: `Запрос доступа к скрытым изделиям бренда “${brand.BrandName}” отправлены`
                })

                this.getBrand(this.currentBrandID)
            })

            this.isOpenRequestAccessBrandModal = false
        },
        openMessageModal() {
            this.isMessageModalOpen = true
            this.hideSubmenu()
        },
        onCloseMessageModal() {
            this.isMessageModalOpen = false
        },
        onMessageSend() {
            // console.log('onMessageSend')
        },
        toggleSubmenu() {
            this.isSubmenuOpened = !this.isSubmenuOpened
        },
        hideSubmenu() {
            this.isSubmenuOpened = false
        },
        async tryGetBrand() {
            await this.getBrand(this.currentBrandID)
        }
    }
}
</script>
